module.exports = __webpack_public_path__ + "static/kelemvor-symbol-SCAG-6ce89bd24c04b9058dc2ae82109c0588.png";